module.exports = __webpack_public_path__ + "static/img/a089.8130377.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a089.jpg
// module id = u4F9
// module chunks = 0